module.exports = "https://cdn.hellotech.com/client-assets/thermostats_desktop_53f97a20c9179a890878372e6e199ec1.webp";